const array = {
	create: (length, fill = null) => Array.from({ length }, (_, i) => fill || i + 1 )
};

export default {
	array
};